import { createContext } from 'react';

export const TransactionHistoryStoreContext = createContext();
